import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { applicationRouteNames } from '../../../app/application-route-names';
import { PermissionsHelper } from '../../../app/helpers/permissions.helper';
import { MpsUser } from '../../../app/models/mps-user.model';
import { MpsUserService } from '../../services/mps-user.service';

export const RequestsManagementGuard = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl(applicationRouteNames.home);
  }

  const user = new MpsUser(loggedInUser);

  if (!user) {
    return router.navigateByUrl(applicationRouteNames.home);
  }

  const isRootListUrl = state.url === '/' + applicationRouteNames.requestsManagement;
  if (isRootListUrl && PermissionsHelper.canAccessRequestsMultipleManagement(user)) {
    return router.navigateByUrl(applicationRouteNames.requestsMultipleManagement);
  }

  return PermissionsHelper.canAccessRequestsManagement(user) ? true : router.navigateByUrl(applicationRouteNames.home);
};
